export default "__VITE_ASSET__3c04a232__"